import Menus from './menus'
import Roles from './roles'
import Users from './users'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/menus`, Menus)
    .useRoute(`${prefix}/users`, Users)
    .useRouter(`${prefix}/roles`, Roles)
}
